var OrganizationMembers;

import OrganizationsTab from 'trunks/vue/admin/components/organizations/organization_tab.js';

import MembersTable from 'trunks/vue/admin/compositions/datable_table/members_table.js';

import UserOrganizationsContainer from '../users_organizations_container.js';

import OrganizationsContent from '../organizations_content.js';

import Actions from '../actions.js';

import OrganizationState from 'trunks/vue/admin/components/organizations/organization_state.js';

export default OrganizationMembers = Vue.extend({
  components: {
    "organization-tab": OrganizationsTab,
    "user-organization-container": UserOrganizationsContainer,
    "members-table": MembersTable,
    "organizations-content": OrganizationsContent,
    "actions": Actions
  },
  props: {
    organization: {
      type: Object,
      required: true
    },
    bindedMembersCount: {
      type: Number
    },
    membersCount: {
      type: Number
    },
    organizationApplicationsCount: {
      type: Number
    },
    fieldable: {
      type: Object
    },
    profileSchema: {
      type: Object
    }
  },
  data: function() {
    return {
      datableGID: new Skylark.Libs.GlobalID(`gid://skylark/Organization/${this.organization.id}`),
      resourceUrl: `/admin/organizations/${this.organization.id}/members`,
      organizationState: OrganizationState
    };
  },
  watch: {
    'organizationState.name': function() {
      return this.organization.name = this.organizationState.name;
    }
  },
  template: `<user-organization-container :title="organization.name">
  <template slot="content">
    <organization-tab activeTab="members"
                      :organizationId="organization.id"
                      :pendingOrganizationApplicationsCount='organizationApplicationsCount' />
    <div class="datable-table">
      <members-table :fieldable="fieldable"
                     :datableGID="datableGID"
                     :resourceUrl="resourceUrl"
                     :organization='organization'
                     ref="membersTableRef">
          <template slot="datable-table-summary" slot-scope='{ selectedRows }'>
            <organizations-content :actionOptions="['add', 'export', 'tags']"
                                   :bindedMembersCount="bindedMembersCount"
                                   :membersCount="membersCount"
                                   :selectedRows='selectedRows'
                                   :organization='organization'
                                   :refreshDataAfterOperation='refreshDataAfterOperationFunc'
                                   @refreshSeletedRowsTags='refreshSeletedRowsTags' />
          </template>
      </members-table>
    </div>
  </template>
</user-organization-container>`,
  methods: {
    refreshDataAfterOperationFunc: function() {
      return this.$refs.membersTableRef.refreshData();
    },
    refreshSeletedRowsTags: function(updateTagsOptions) {
      this.$refs.membersTableRef.refreshSeletedRowsTags(updateTagsOptions);
      return this.$refs.membersTableRef.resetTableAllSelected();
    }
  }
});
